export function join(classes: string[]) {
  return classes.join(' ').trim();
}

export function insertIf(condition: boolean, elements: string) {
  return condition ? [elements] : [];
}
